// extracted by mini-css-extract-plugin
export default {"participant":"ParticipantInfo_participant__fEai-","icon":"ParticipantInfo_icon__w5DGR"};